import client from './client'
import install from './install'

// 子模块

import api from './api'

export default class SmsApi {
  constructor (options) {
    if (SmsApi.instance) {
      throw new Error('SmsApi is singleton')
    }
    SmsApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.api = api
  }

  static getInstance () {
    return SmsApi.instance
  }
}

SmsApi.instance = null
SmsApi.install = install



// WEBPACK FOOTER //
// ./src/apis/sms-api/index.js